import { createWebSocketStore } from 'src/components/#services/helpers';
export const getMembershipList = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_getAllForPurchase',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const purchaseMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_purchaseMembershipFromSite',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getAllActiveMemberships = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_getAllMyActive',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const checkMembershipAvailable = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_checkIsMembershipAvailable',
        agent: 'transactions',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
